export const ApiRoutes = {
    auth: {
        register: "/auth/users/",
        login: "/auth/jwt/create/",
        reset_password: "/user/reset-password",
        forgot_password: "/user/forgot-password",
        logout: "/user/logout"
    },
    home: "/dashboard-details",
    account: "/user/change-password",
    home_image: {
        create: "/homepage-cover",
        list: "/homepage-cover",
    },
    member: {
        create: "/auth/users/",
        list: "/users/",
        edit: "/user/{id}",
        delete: "/user/{id}",
        detail: "/user/{id}", // Get specific member by ID
    },
    blog: {
        create: "/blogs/",
        list: "/blogs/",
        edit: "/blog/{id}",
        delete: "/blog/{id}",
        detail: "/blog/{id}", // Get specific blog by ID
    },
    popular_place: {
        create: "/popularplaces",
        list: "/popularplaces",
        edit: "/popularplace/{id}",
        delete: "/popularplace/{id}",
        detail: "/popularplace/{id}", // Get specific popular place by ID
    },
    feature: {
        create: "/features",
        list: "/features",
        edit: "/feature/{id}",
        delete: "/feature/{id}",
        detail: "/features/{id}", // Get specific feature by ID
    },
    owner: {
        create: "/owners/",
        list: "/owners/", // List owners with name filter "/owners/?name={name}"
        edit: "/owner/{id}",
        delete: "/owner/{id}",
        detail: "/owner/{id}", // Get specific owner by ID
    },
    client: {
        create: "/clients/",
        list: "/clients/", // List clients with search name or inquiry_id filter "/clients/?search={nameOrInquiryId}"
        edit: "/client/{id}",
        delete: "/client/{id}",
        detail: "/client/{id}", // Get specific client by ID
    },
    property: {
        create: "/properties/",
        list: "/properties/", // List properties with search code and name, status and type filter  "/properties/?search=bo&status=sale&type=apartment"
        export: "/properties/export/", // Export all properties without pagination
        edit: "/property/{id}",
        delete: "/property/{id}",
        detail: "/property/{id}", // Get specific property by ID
        type: "/property-types/", // List property types
        typeByCategory: "/property-types/by-category/{category_id}", // List property types by category
        category: "/property-categories/", // List property categories
        owner: "/property/owners",
        city: "/cities", // List cities
        district: "/districts/by-city/{city_id}", // List districts by city ID
        commune: "/communes/by-district/{district_id}", // List communes by district ID
        image: "/property-images", // List property images
    },
}